<app-base-template (modal)="openModal(content)" (searchmodal)="searchModal()" (tabledata)="getTableData()"
  [displayData]="displayData" [nextOffset]="nextOffset" [previousOffset]="previousOffset"
  (offset)="getNewTableData($event)" (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"
  [dataLoaded]="dataLoaded" [showSearch]="showSearch"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add user</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group mar_top">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text radius-0"><i class="fa fa-user fa-fw"></i></div>
        </div>
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="userName" placeholder="Name">
      </div>
    </div>
    <div class="form-group ">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text radius-0"><i class="fa fa-user fa-fw"></i></div>
        </div>
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="loginName" placeholder="Login ID">
      </div>
    </div>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text radius-0"><i class="fa fa-phone"></i></div>
        </div>
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="mobile" placeholder="Contact Number">
      </div>
    </div>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text radius-0"><i class="fa fa-envelope-o fa-fw"></i></div>
        </div>
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="email" placeholder="Email ID">
      </div>
    </div>
    <div class="form-group">
      <textarea class="form-control radius-0 font-13" [(ngModel)]="address" placeholder="Address"></textarea>
    </div>
    <!-- <div class="form-group">
      <input type="password" class="form-control radius-0 font-13" [(ngModel)]="password"
             placeholder="Initial Password">
    </div> -->

    <form [formGroup]="passwords">
      <mat-form-field>
        <input matInput class="font-13" placeholder="Password" [(ngModel)]="password"
          [type]="hides ? 'password' : 'text'" formControlName="password" required>
        <mat-icon matSuffix (click)="hides = !hides">{{hides ? 'visibility_off' : 'visibility'}}</mat-icon>
        <mat-hint *ngIf="!passwordInput1.value">Enter your password</mat-hint>
      </mat-form-field>
    </form>

    <div class="form-group font-13">
      <mat-checkbox [(ngModel)]="isServiceUser">Service User</mat-checkbox>
    </div>
    <div class=" pad-8">
      <button type="button" class="btn btn-danger float-right radius-0 " (click)="c()">Cancel</button>
      <button type="button" class="btn btn-success float-right radius-0 mar_Right" (click)="save()">Save</button>

    </div>
  </div>
</ng-template>


<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search user</div>
  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group mar_top">
      <input type="text" class="form-control radius-0 font-13" placeholder=" Enter Login ID OR Name"
        [(ngModel)]="userSelected" matInput [formControl]="searchUser" [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getUserDetails()">
        <mat-option *ngIf="isLoading" class="is-loading">
          <mat-spinner diameter="50"></mat-spinner>
        </mat-option>
        <ng-container *ngIf="!isLoading">
          <mat-option *ngFor="let user of usrs" [value]="user.login_name">
            {{ user.name }} - {{user.login_name}}
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </div>

    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" placeholder="User Name" readonly [(ngModel)]="userName">
    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success float-right radius-0 mar_Right" (click)="search()">search</button>
    <button type="button" class="btn btn-danger float-right radius-0 " (click)="c()">Cancel</button>
  </div>
</ng-template>

<ng-template #content1 let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Reset Password</div>
  </div>
  <div class="modal-body">
    <!-- <div class="note">
              <p class="p">Please Note The Following Password Requirement:</p>
              <ul class="a">
                  <li>Must be a minimum of 8 characters and a maximum of 20 characters.</li>
                  <li>Must contain a mix of uppercase and lowercase letters.</li>
                  <li>Must contain at least one number or non-alphanumeric symbol (eg.!?&).</li>
                  <li>Cannot contain any spaces.</li>
  
              </ul>
  
          </div>
   -->
    <form [formGroup]="signin">
      <mat-form-field>
        <input matInput class="font-13" placeholder="Password" [(ngModel)]="cPassword"
          [type]="hide ? 'password' : 'text'" formControlName="password" required>
        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        <mat-hint *ngIf="!passwordInput.value">Enter your password</mat-hint>
      </mat-form-field>
    </form>
    <div class="form-group">

      <input type="password" class="form-control font-13" [(ngModel)]="confirmpassword" placeholder="Confirm Password">

    </div>

  </div>
  <div class="modal-footer pad-8">

    <button type="button" class="btn btn-success float-right radius-0" (click)="confirm()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>

  </div>

</ng-template>


<notifier-container></notifier-container>